import {fontsSize} from "./Elements";

const FormInput = ({type, placeholder, value, onChange, readOnly}) => {
    return (
        <input
            className={`w-full p-[1vh] mb-[1vh] border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 ${fontsSize.m}`}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required
            readOnly={readOnly ? readOnly : false}
        />
    );
};

export default FormInput;
